module.exports = __webpack_public_path__ + "static/media/al.fc4c9992.png";